import { Link as DSLink } from "@icg360/design-system";

import styles from "./email-icon-link.module.scss";

type EmailIconLinkProps = {
  email: string;
};

export const EmailIconLink = ({ email }: EmailIconLinkProps) => (
  <DSLink href={`mailto:${email}`} leadingIcon="Envelope">
    <span className={styles.email}>{email}</span>
  </DSLink>
);
